<template>
    <div>
        <div>
            <strong>开启跑马灯游戏：</strong>
            <el-switch
                    style="margin-right: 80px"
                    @change="statusChange"
                    :value="horseRaceLamp.status"
                    :active-value="1"
                    :inactive-value="0"/>
            <strong>当前奖池：</strong>
            <span v-text="horseRaceLamp.kdou/100"></span>
            <el-button style="margin-left: 20px" type="primary" size="mini" @click="show = true">注入</el-button>
            <el-button style="margin-left: 20px" type="primary" size="mini" @click="reduceShow = true">减少</el-button>
        </div>
        <el-card style="margin: 20px 0">
            <div slot="header">
                <el-date-picker
                        v-model="date"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"/>
                <el-button @click="getTotal" style="margin-left: 15px" type="primary">查询</el-button>
            </div>
            <div class="common-table" style="margin-top:0;min-height: auto">
                <el-table
                        show-summary
                        :data="totalList"
                        v-loading="loading">
                    <el-table-column align="center" min-width="120" label="奖金级别">
                        <template slot-scope="scope">{{scope.row.rewardsLevel | rewardsLevelName}}</template>
                    </el-table-column>
                    <el-table-column align="center" min-width="120" label="获奖人数" prop="number"/>
                    <el-table-column align="center" min-width="150" label="获奖金豆数量" prop="kdou"/>
                </el-table>
            </div>
        </el-card>
        <el-card class="common-el-card-flex" style="min-height: 500px">
            <h3>大奖记录</h3>
            <div class="common-table" style="margin-top: 0;min-height: auto">
                <el-table
                        row-key="userId"
                        :data="list"
                        height="100%">
                    <el-table-column type="index" align="center" label="编号"/>
                    <el-table-column align="center" min-width="150" label="玩家昵称" prop="nickName"/>
                    <el-table-column align="center" label="玩家ID" prop="userId"/>
                    <el-table-column align="center" min-width="120" label="奖金级别">
                        <template slot-scope="scope">{{scope.row.rewardsLevel | rewardsLevelName}}</template>
                    </el-table-column>
                    <el-table-column align="center" min-width="120" label="获得金豆数量" prop="kdou"/>
                    <el-table-column align="center" min-width="150" label="获奖时间" prop="rewardsTime"/>
                </el-table>
            </div>
        </el-card>

        <div v-show="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>跑马灯奖池注入</h3>
                <div class="common-popup-table" style="padding-bottom: 20px">
                    <el-input v-model="kdou" type="number" placeholder="请输入注入奖池金额" style="width: 280px" size="medium">
                        <template slot="append">金豆</template>
                    </el-input>
                </div>
                <footer>
                    <el-button size="small" @click="closeAdd">取消</el-button>
                    <el-button type="primary" size="small" @click="addFunc">确定</el-button>
                </footer>
            </div>
        </div>
        <div v-show="reduceShow" class="common-popup-bg">
            <div class="common-popup">
                <h3>跑马灯奖池减少</h3>
                <div class="common-popup-table" style="padding-bottom: 20px">
                    <el-input v-model="rdou" type="number" placeholder="请输入减少的奖池金额" style="width: 280px" size="medium">
                        <template slot="append">金豆</template>
                    </el-input>
                </div>
                <footer>
                    <el-button size="small" @click="closeAdd">取消</el-button>
                    <el-button type="primary" size="small" @click="reduceFunc">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                show:false,
                reduceShow:false,
                date: null,
                loading: false,
                totalList: [],
                list: [],
                kdou:'',
                rdou:''
            }
        },
        computed: {
            ...mapState('activity', ['horseRaceLamp'])
        },
        created() {
            this.getHorseRaceLamp();
            // 大奖记录
            this.getHorseRaceLampRecord().then(res => {
                this.list = res.data
            })
        },
        filters: {
            rewardsLevelName(type) {
                let arr = ['一等奖','二等奖','三等奖','四等奖','五等奖','六等奖','七等奖'];
                return arr[type - 1];
            }
        },
        methods: {
            ...mapActions('activity', ['getHorseRaceLamp', 'updateHorseRaceLampStatus', 'getHorseRaceLampRecord', 'getHorseRaceLampTotal','addHorseRaceLampAccount','reduceHorseRaceLampAccount']),
            getTotal() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return
                }
                this.getHorseRaceLampTotal({
                    startDate: this.date[0],
                    endDate: this.date[1],
                }).then(res => {
                    this.totalList = res.data
                })
            },
            statusChange(value) {
                this.updateHorseRaceLampStatus({
                    status: value
                }).then(() => {
                    this.$message.success('修改成功')
                })
            },
            // 注入金豆
            addFunc(){
                var dou = this.kdou;
                var self = this;
                if(dou < 0){
                    self.$message.error('请输入大于0的数');
                    return;
                }else if(dou.indexOf('.')>=0){
                    self.$message.error('请输入整数');
                    return;
                }else{
                    if(dou[0]==0){
                        self.$message.error('首位不能为0');
                        return;
                    }
                    for(var i=0;i<dou.length;i++){
                        if(dou[i]==' '){
                            self.$message.error('不能输入空格');
                            return;
                        }else if('0123456789'.indexOf(dou[i])<0){
                            self.$message.error('不能输入非数字');
                            return;
                        }
                    }
                }
                this.addHorseRaceLampAccount({
                    kdou:this.kdou
                }).then(()=>{
                    this.$message.success('注入成功');
                    this.closeAdd();
                })
            },
            // 减少金豆
            reduceFunc(){
                var dou = this.rdou;
                var self = this;
                if(dou < 0){
                    self.$message.error('请输入大于0的数');
                    return;
                }else if(dou.indexOf('.')>=0){
                    self.$message.error('请输入整数');
                    return;
                }else{
                    if(dou[0]==0){
                        self.$message.error('首位不能为0');
                        return;
                    }
                    for(var i=0;i<dou.length;i++){
                        if(dou[i]==' '){
                            self.$message.error('不能输入空格');
                            return;
                        }else if('0123456789'.indexOf(dou[i])<0){
                            self.$message.error('不能输入非数字');
                            return;
                        }
                    }
                }
                self.reduceHorseRaceLampAccount({
                    kdou:self.rdou
                }).then(()=>{
                    self.$message.success('减少成功');
                    self.closeAdd();
                })
            },
            closeAdd(){
                this.kdou = '';
                this.show = false;
                this.rdou = '';
                this.reduceShow = false;
            }
        }
    }
</script>